export default __webpack_public_path__ + "static/media/home1.e198ac55.png";